import styled from 'styled-components'
// import { rem } from 'polished'
import { Flex, Box, Link } from 'rebass'

import { media } from '../../../utils/style'
import IconArrowRight from '../../../vectors/IconArrowRight'
import IconInfo from '../../../vectors/IconInfo'

const CtrlFlexWrapper = styled(Flex)`
  &.focused .item {
    display: none;
  }
  &.focused .item.focused,
  &.focused .item.focused {
    display: block;
  }
`

const ModalItem = styled(Box)`
  width: 100%;
`

const ModalSelectItem = styled(Link)`
  display: block;
  position: relative;
  cursor: pointer;
  color: ${(props) => props.theme.colors.blue};
  font-weight: ${(props) => props.theme.weights[1]};
  background: ${(props) => props.theme.colors.blue_light};
  border-top: 1px ${(props) => props.theme.colors.grey_light_op30} solid;
  z-index: 1;
  text-align: ${(props) => (!props.open ? 'left' : 'center')};
  path {
    transition: fill 0.5s ${(props) => props.theme.ease.ease_out_expo};
  }
  &:hover {
    path {
      fill: ${(props) => props.theme.colors.grey};
    }
  }
`

const ArrowRight = styled(IconArrowRight)`
  position: absolute;
  top: 50%;
  ${(props) => (!props.open ? 'right: 8%;' : 'left: 8%;')}
  transform: ${(props) =>
    !props.open ? 'translateY(-50%)' : 'translateY(-50%) scaleX(-1)'};
  path {
    fill: ${(props) => props.theme.colors.grey_light};
  }
`

const Info = styled(IconInfo)`
  margin-right: 15px;
  margin-bottom: -5px;
`

const ModalSection = styled(Box)`
  position: relative;
  background: white;
  border-top: 1px ${(props) => props.theme.colors.grey_light_op30} solid;
  width: 100%;
  min-height: 100px;
  z-index: 1;
`

const Shadow = styled(Box)`
  ${media.LargeScreenUp`
  &::after {
    content:'';
    position: absolute;
    bottom: 2%;
    left: 50%;
    transform: translateX(-50%);
    width: 90%;
    height: 50%;
    box-shadow: 0 20px 40px 0px rgba(66,76,94,0.2),
                0 15px 35px 0 rgba(0,0,0,0.15);
  }
  `};
`

export {
  ArrowRight,
  Info,
  CtrlFlexWrapper,
  ModalItem,
  ModalSection,
  ModalSelectItem,
  Shadow
}
